import { render, staticRenderFns } from "./front_merced.vue?vue&type=template&id=8c22497c&"
import script from "./front_merced.vue?vue&type=script&lang=js&"
export * from "./front_merced.vue?vue&type=script&lang=js&"
import style0 from "./front_merced.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports